import { Profile } from 'oidc-client';
import React, { useState } from 'react';
import { ActionOption, ModuleName } from '../../../core/models/enum';
import { isUserAllowed } from '../../../helpers/CheckPermissionHelper';
import { liveClockPreference, rememberLiveClock } from './browserClock';
import LiveClockAction from './LiveClockAction';

const LiveClockPreferenceAction: React.FC<{ matchId: number; userProfile?: Profile }> = ({ matchId, userProfile }) => {
    const [enabled, setEnabled] = useState(() => liveClockPreference(matchId));
    if (!userProfile || !isUserAllowed(userProfile, ModuleName.Matches, ActionOption.Update, matchId)) return null;

    return <LiveClockAction enabled={enabled} onChange={value => {
        rememberLiveClock(matchId, value);
        setEnabled(value);
    }} />;
};

export default LiveClockPreferenceAction;
